<div class="root" *ngIf="data">
    <figure class="root__figure">
        <img [src]="data.image?.value?.url" [alt]="data.alternativeText?.value" (load)="showCaption = true" class="root__image">
        <figcaption *ngIf="showCaption" [innerHTML]="data.description?.value" class="root__caption"></figcaption>
    </figure>
</div>
